/*
 * Orléa — socle animation (sections custom orlea-*)
 * Câble Lenis sur le ticker GSAP (une seule boucle rAF) ; fallback natif si GSAP absent.
 * La boucle rAF historique de theme.liquid a été retirée — c'est CE fichier qui anime Lenis.
 * v2 (2026-07-20) : enregistre aussi Observer, Draggable, InertiaPlugin, Flip (chantier Osmo).
 * v3 (2026-07-20, portage V8) : helpers globaux data-oparallax (parallaxe différentielle,
 * le « feeling Locomotive » sans Locomotive) et data-owash (lavis du fond au défilement).
 */
(function () {
  if (!window.lenis) return;

  function nativeRaf() {
    function raf(time) {
      window.lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
  }

  if (window.gsap && window.ScrollTrigger) {
    gsap.registerPlugin(ScrollTrigger);
    if (window.SplitText) gsap.registerPlugin(SplitText);
    if (window.Observer) gsap.registerPlugin(Observer);
    if (window.Draggable) gsap.registerPlugin(Draggable);
    if (window.InertiaPlugin) gsap.registerPlugin(InertiaPlugin);
    if (window.Flip) gsap.registerPlugin(Flip);

    // Lenis pilote le scroll natif de window : pas de scrollerProxy nécessaire.
    window.lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(function (time) {
      window.lenis.raf(time * 1000);
    });
    gsap.ticker.lagSmoothing(0);

    // v3 — Parallaxe différentielle : tout élément avec data-oparallax="0.12"
    // dérive de yPercent -12 sur sa traversée du viewport (scrub).
    // Les sections posent l'attribut ; le mécanisme vit ICI (une seule implémentation).
    function initOParallax() {
      var mm = gsap.matchMedia();
      mm.add('(prefers-reduced-motion: no-preference)', function () {
        document.querySelectorAll('[data-oparallax]').forEach(function (el) {
          var speed = parseFloat(el.dataset.oparallax) || 0.1;
          gsap.to(el, {
            yPercent: -(speed * 100),
            ease: 'none',
            scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: true }
          });
        });
      });
    }

    // v3 — Lavis du fond : le body fond vers la teinte data-owash de chaque section/bloc
    // à son entrée (scrub). Les sections « ouvertes » deviennent transparentes via la
    // classe html.owash-on (chaque section gère sa propre règle CSS de transparence).
    // immediateRender:false obligatoire (tweens en chaîne sur la même propriété).
    function initWashMorph() {
      var sections = document.querySelectorAll('[data-owash]');
      if (!sections.length) return;
      var mm = gsap.matchMedia();
      mm.add('(prefers-reduced-motion: no-preference)', function () {
        document.documentElement.classList.add('owash-on');
        sections.forEach(function (section) {
          gsap.to(document.body, {
            backgroundColor: section.dataset.owash,
            ease: 'none',
            immediateRender: false,
            scrollTrigger: { trigger: section, start: 'top 75%', end: 'top 25%', scrub: true }
          });
        });
        return function () { document.documentElement.classList.remove('owash-on'); };
      });
    }

    // Après le parse des sections (les <script> inline s'exécutent avant les defer) :
    // les attributs data-* sont déjà posés quand ce fichier defer s'exécute.
    initOParallax();
    initWashMorph();

    // Les sliders/reco du thème s'injectent tard (IntersectionObserver, rootMargin 500px) :
    // un refresh après charge complète corrige les start/end calculés trop tôt.
    window.addEventListener('load', function () {
      ScrollTrigger.refresh();
    });
    // Le swap des fontes peut arriver après load (Cormorant/Taviraj) : re-mesurer.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { ScrollTrigger.refresh(); });
    }
  } else {
    nativeRaf();
  }
})();
